import {
  getIsForInAppPresentation,
  IndexLayout,
  IndexLayoutExtraProps,
  routes as routesOutside,
} from '@sketch/modules-common'

import {
  PrivateRoute,
  ForgotPasswordView,
  ResetPasswordView,
  SignInView,
  SignUpView,
  ChooseYourPath,
  SsoErrorPage,
  SsoSuccessfulSignInView,
  SsoTosPage,
} from 'cloud-frontend'
import PublicOnlyRoute from 'containers/PublicOnlyRoute'

import { Location } from 'history'

import React from 'react'
import { Route, Switch } from 'react-router-dom'

import { authRoutes as routes } from './routes'
import { SsoLinkAccountRoute } from './SsoLinkAccountRoute'
import { SsoSignInRoute } from './SsoSingInRoute'

interface LocationState {
  from?: Location
}
type WithFromLocation<T extends { location: any }> = OmitSafe<T, 'location'> & {
  location: Location<LocationState>
}

// /**
//  * TODO: Come up with better routing strategies when rendering Layouts firsts, views second
//  * see: https://github.com/sketch-hq/Cloud/issues/16895
//  */
const AuthRoutesSwitch = (layoutProps: IndexLayoutExtraProps) => {
  return (
    <Switch>
      <PrivateRoute
        isInLayout
        path={routes.CHOOSE_YOUR_PATH.template()}
        render={routeProps => (
          <ChooseYourPath {...layoutProps} {...routeProps} />
        )}
      />
      <PublicOnlyRoute
        exact
        path={routes.SIGN_IN.template()}
        render={routeProps => (
          <SignInView
            {...(routeProps as WithFromLocation<typeof routeProps>)}
            {...layoutProps}
          />
        )}
      />
      <PublicOnlyRoute
        exact
        path={routes.SIGN_UP.template()}
        render={routeProps => (
          <SignUpView
            {...(routeProps as WithFromLocation<typeof routeProps>)}
            {...layoutProps}
          />
        )}
      />

      <PublicOnlyRoute
        exact
        path={routes.FORGOT_PASSWORD.template()}
        redirectPath={routesOutside.PERSONAL_SETTINGS.template()}
        render={routeProps => (
          <ForgotPasswordView
            {...(routeProps as WithFromLocation<typeof routeProps>)}
            {...layoutProps}
          />
        )}
      />
      <Route
        exact
        path={routes.RESET_PASSWORD.template()}
        render={routeProps => (
          <ResetPasswordView
            {...(routeProps as WithFromLocation<typeof routeProps>)}
            {...layoutProps}
          />
        )}
      />
      <Route
        exact
        path={routes.SSO_SIGN_IN.template()}
        render={routeProps => (
          <SsoSignInRoute {...routeProps} {...layoutProps} />
        )}
      />
      <Route
        exact
        path={routes.SSO_ERROR.template()}
        render={routeProps => <SsoErrorPage {...routeProps} {...layoutProps} />}
      />
      <Route
        exact
        path={routes.SSO_SUCCESSFUL_SIGN_IN.template()}
        render={routeProps => (
          <SsoSuccessfulSignInView {...routeProps} {...layoutProps} />
        )}
      />
      <Route
        exact
        path={routes.SSO_LINK_ACCOUNT.template()}
        render={routeProps => (
          <SsoLinkAccountRoute {...routeProps} {...layoutProps} />
        )}
      />
      <Route
        exact
        path={routes.SSO_TOS.template()}
        render={routeProps => <SsoTosPage {...routeProps} {...layoutProps} />}
      />
    </Switch>
  )
}

export const AuthRoutes = () => {
  const disableLogoLink = getIsForInAppPresentation()
  return (
    <IndexLayout
      disableLogoLink={disableLogoLink}
      render={layoutProps => <AuthRoutesSwitch {...layoutProps} />}
    />
  )
}
